export { default } from './PageAdPlacement.vue'
